$ = jQuery;
/*Functions*/

/*COOKIES*/
function setCookie(name,value,days) {
    if (days) {
        var date = new Date();
        date.setTime(date.getTime()+(days*24*60*60*1000));
        var expires = "; expires="+date.toGMTString();
    }
    else var expires = '';
    document.cookie = name+"="+value+expires+"; path=/";
}

function getCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for(var i=0;i < ca.length;i++) {
        var c = ca[i];
        while (c.charAt(0)==' ') c = c.substring(1,c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
    }
    return false;
}
function deleteCookie(name) {
    setCookie(name,"",-1);
}

function redirect(URL, e)
{   e.preventDefault();
    window.open(URL);
    return false;
}

function starsHover() {
    var t = $(".rate-block .rate-bar").innerWidth();
    $(".rate-block").on("click", function() {
        if (!$(this).data("clicked")) {
            var e = parseInt($(".rating_count .count").text()) + 1;
            $(".rating_count .count").text(e);
            var data = {
                'action': 'count',
                'count': $(".rating_count .count").html(),
                'id': $(".rating_count .count").attr('data-id')
            };
            $.ajax({
                url: '/wp-admin/admin-ajax.php',
                data:data,
                type:'POST',
                success:function(data){
                    if( data ) {
                        $(".rating_count .count").text(data);
                    }
                }
            });
        }
        $(this).data("clicked", !0)
    }), $(".rate-block").on("mousemove", function(e) {
        if (!$(this).data("clicked")) {
            var t = e.clientX - $(this).offset().left;
            $(".rate-block .rate-bar").css("width", t)
        }
    }), $(".rate-block").on("mouseleave", function(e) {
        $(".rate-block .rate-bar").css("width", t)
    })

}



function toCasino() {
    var btn = $('span.to_casino');
    btn.on('click',function (e) {
        var a = $(this),
            url = a.attr('data-casino');
        casinoUrl = '/go-to/?casino-url='+ url +'';
        if(casinoUrl){
            window.open(casinoUrl);
        }
        else return false;
    });
}
$( document ).ajaxComplete(function() {
    toCasino();
});
$(document).ready(function () {
    "use strict";
    /*Init*/
    $("select").selbel();
    toCasino();
    starsHover();
    var fancy = $('[data-src = "#hidden-content"]');
    fancy.fancybox();
    if ($('.flex_parent').hasClass('has_popup')) {
        setTimeout(function () {
            fancy.click();
        }, 3000);
    }

    $('.close_casino').on('click', function() {
        fancy.click();
    });


    /*Sliders*/

    var bonusSlider = new Swiper('.sidebar-best-online-casino .swiper-container',{
        autoplayDisableOnInteraction: false,
        preventClicks: true,
        preventClicksPropagation:false,
        loop: true,
        speed: 1000,
        loopFillGroupWithBlank: true,
        autoplay: {
            delay: 4000,
            disableOnInteraction: false
        },
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        }
    });
    /* Sidebar Slider */
    var sidebarSlider = new Swiper('.slider-casinos-block .swiper-container', {
        direction: 'vertical',
        slidesPerView: 4,
        speed: 1000,
        loop: true,
        noSwiping: true,
        noSwipingClass: 'swiper-no-swiping',
        loopFillGroupWithBlank: true,
        autoplayDisableOnInteraction: false,
        preventClicks: true,
        preventClicksPropagation:false,
        autoplay: {
            delay: 2500,
            disableOnInteraction: false
        },
        navigation: {
            nextEl: '.slider-casinos-block .swiper-button-next',
            prevEl: '.slider-casinos-block .swiper-button-prev'
        }
    });



    /*menu 2 columns*/

    $('.two_columns_1').parent().next('ul').addClass('two_cols');




    $(window).scroll(function () {
        if ($(this).scrollTop() > 1) {
            $('body').addClass("fixed");
        } else {
            $('body').removeClass("fixed");
        }
        if ($(this).scrollTop() > 100) {
            $(".top-up").addClass('active');
        }
        else {
            $(".top-up").removeClass('active');
        }
    });

    if ($(window).scrollTop() > 1) {
        $('body').addClass("fixed");
    } else {
        $('body').removeClass("fixed");
    }

    if ($(this).scrollTop() > 100) {
        $(".top-up").addClass('active');
    }
    else {
        $(".top-up").removeClass('active');
    }

    $(".top-up").on("click","span", function () {
        $('html, body').animate({
            scrollTop: 0
        }, 1000);
    });

    /*FAQ*/
    var acc_var = $('.faq .title');
    acc_var.click(function() {
        if($(this).hasClass('opened')){
            false;
        }
        else {
            $('.faq').find('.info').slideUp(300);
            $(this).next().slideToggle(300);
            acc_var.removeClass('opened');
            $(this).addClass('opened');
        }
    });
    acc_var.eq(2).click();

    $('[id ^= bg-showmore-hidden] p:first-of-type, [id ^= bg-showmore-hidden] p:last-of-type').remove();
    var expand_content = $('[id ^= bg-showmore-hidden]');
    function expandShow() {
        expand_content.fadeIn(200);
    }
    function expandHide() {
        expand_content.fadeOut(200);
        $('.bg-showmore-plg-link').css('display','inline-block');
    }
    if ($(window).width()>=1025) {
        /*expandShow();*/
    }
    if ($(window).width()<=1024) {
        /*expandShow();
        $(window).on('load', function () {
            setTimeout(expandHide,5000);
        });*/
    };

    /*Accordeon*/
    function accordeonHide() {
        $('.accordeon').find('.accordeon_item_info').slideUp(300);
    }
    setTimeout(accordeonHide,1000);
    var o = $(".accordeon").find(".accordeon_item_title");
    o.click(function() {
        $(this).hasClass("opened") ? (o.removeClass("opened"), $(this).next().slideToggle(300), $(".accordeon").find(".accordeon_item_info").slideUp(300)) : ($(".accordeon").find(".accordeon_item_info").slideUp(300), $(this).next().slideToggle(300), o.removeClass("opened"), $(this).addClass("opened"))
    })


    /*Table*/
    $('.table-full tr:nth-child(6)').after('<tr class="between_parts"></tr>');

    $('.mob-expand').click(function () {
        $(this).parent().next().css('opacity','1').css('visibility','visible');
        $(this).parent().next().find('.wrap').slideToggle();
    });

    /* Open mobile tables */
    function openMobSingleTables() {

        if($(window).width() < 768) {
            $('.single_table tr:nth-child(1)').next().css('opacity','1').css('visibility','visible');
            $('.single_table tr:nth-child(1)').next().find('.wrap').css('display','block');
        } else {
            $('.single_table tr:nth-child(1)').next().css('opacity','0').css('visibility','hidden');
            $('.single_table tr:nth-child(1)').next().find('.wrap').css('display','none');
        }
    }
    function openMobTables(num) {

        if($(window).width() < 768) {
            $('.table-full tr:nth-child('+num+')').next().css('opacity','1').css('visibility','visible');
            $('.table-full tr:nth-child('+num+')').next().find('.wrap').css('display','block');
        } else {
            $('.table-full tr:nth-child('+num+')').next().css('opacity','0').css('visibility','hidden');
            $('.table-full tr:nth-child('+num+')').next().find('.wrap').css('display','none');
        }
    }

    openMobSingleTables();
    $(window).on('resize',function() {
        openMobSingleTables();
    });

    $('iframe,embed').attr('src', function () {
        return $(this).attr('src').replace('http:','');
    });
    $('object').attr('data', function () {
        return $(this).attr('data').replace('http:','');
    });

    /*taber*/
    var tabi = $('.taber .title_list span');
    tabi.click(function() {
        tabi.removeClass('active');
        $(this).addClass('active');
        $('.taber .tab_content .tab_container').removeClass('visible');
        $('.taber .tab_content .tab_container').stop(300).hide().eq($(this).index()).stop(300).fadeIn(500).addClass('visible');
    });
    tabi.eq(0).click();


    /*Progres bar*/
    $('.ratingbar').each(function () {
        $(this).find('.skillbar_bar').animate({
            width: $(this).attr('data-percent')
        },{
            duration: 1500,
            easing: 'swing'});
    });
    $('.counter').each(function () {
        var count = $(this);
        $({countNum: count.text()}).animate({
            countNum: count.attr('data-count')
        }, {
            duration: 1500,
            easing: 'linear',
            step: function () {
                count.text(Math.floor(this.countNum));
            },
            complete: function () {
                count.text(this.countNum);
            }
        });
    });

    /*Spinner*/

    var prices = [
        {
            name: 'Dunder Casino'
        },
        {
            name: '888 Casino'
        },
        {
            name: 'Casinoland'
        },
        {
            name: 'Leo Vegas Casino'
        },
        {
            name: 'Royal Panda Casino'
        },
        {
            name: 'Mr. Green Casino'
        },
        {
            name: 'Casino Room'
        },
        {
            name: 'DrückGlück Casino'
        }
    ];

    $(function() {

        var $r = $('.roulette').fortune(prices);

        var clickHandler = function() {
            var casinoLink = 0;
            $('.spinner').off('click');
            $('.spinner span').hide();
            $r.spin().done(function(price) {
                $('.price').text('Spielen '+ price.name);
                switch(price.name) {
                    case 'Dunder Casino':
                        casinoLink = 'Dunder';
                        break;
                    case '888 Casino':
                        casinoLink = '888';
                        break;
                    case 'Casinoland':
                        casinoLink = 'casinoland';
                        break;
                    case 'Leo Vegas Casino':
                        casinoLink = 'leovegas';
                        break;
                    case 'Royal Panda Casino':
                        casinoLink = 'royalpanda';
                        break;
                    case 'Mr. Green Casino':
                        casinoLink = 'MrGreen';
                        break;
                    case 'Casino Room':
                        casinoLink = 'casinoroom';
                        break;
                    case 'DrückGlück Casino':
                        casinoLink = 'druckgluck';
                        break;
                    default:
                        casinoLink = 'casinoland';
                        break;
                }
                $('#hidden-spin-content .to_casino').attr('data-casino',casinoLink).addClass('active');
                $('#hidden-spin-content .info').addClass('hide');
                $('.spinner').on('click', clickHandler).addClass('hide');
            });

        };

        $('.spinner').on('click', clickHandler);
    });
    var fancySpinner = $('a.spinnerButton');
    if(fancySpinner[0]){
        fancySpinner.fancybox({
            afterClose: function(){
                $('.spinner_button').addClass('active');
            }
        });
        if ($('.footer').find('a.spinnerButton')&&!getCookie('spinner')) {
            setTimeout(function () {
                fancySpinner.click();
                setCookie('spinner','true',10);
            },10000);
        }
        if(getCookie('spinner')){
            $('.spinner_button').addClass('active');
        }
    }

    /*Scroll plugin fix*/
    $('.toc_list a').on('click',function(e){e.preventDefault()})

});

$(window).load(function(){
    $('.blog-posts').masonry({
        itemSelector: '.blog-post-item',
        horizontalOrder: true
    });
});

/*Ajax*/
jQuery(function($){
    if ($('body').find('.taber')) {
        var page = 0;
        var current_page = 0;
        var step = parseInt($('.visible .true_loadmore').attr('data-step'));
        page = parseInt($('.visible .true_loadmore').attr('data-page')) + 2;
        $('.taber .title_list span').on('click', function () {

            var visible = $('.visible .true_loadmore');
            // visible.removeAttr('paged');

            if(visible.attr('paged')) {
                current_page = parseInt(visible.attr('paged'));
            }
            else {
                current_page = parseInt(visible.attr('data-page'));
            }
            if (visible.attr('paged')) {
                current_page = current_page + step + 2;
            };
        });
        $('.taber .title_list span').eq(0).click();
        $('.true_loadmore').click(function(){
            var loadmore = $(this);
            if ($(this).attr('paged')) {
                current_page = current_page -1;
            };
            $(this).addClass('load').text('').append('<div class="loader"></div>');
            var data = {
                'action': 'loadmore',
                'query': loadmore.attr('data-true-posts'),
                'page' : current_page,
                'step' : loadmore.attr('data-step'),
                'max_pages' : loadmore.attr('data-max-pages')
            };
            $.ajax({
                url:loadmore.attr('data-url'),
                data:data,
                type:'POST',
                success:function(data){
                    if( data ) {
                        $('.loader').remove();
                        loadmore.removeClass('load').text('Show More').before(data);
                        $('.games .growIn').addClass('go');
                        current_page = parseInt(current_page) + page;
                        console.log(current_page);
                        if (current_page >= loadmore.attr('data-max-pages')) loadmore.remove();
                    } else {
                        loadmore.remove();
                        $('.games .growIn').addClass('go');
                    }
                    toCasino();
                }
            });
            $(this).attr('paged',current_page);
        });
    }
});
if($('.t-table-std-ajax')[0]){
    jQuery(function($){
        var page_table = parseInt(ajax_Object.current_page)+2;

        $('#true_loadmore').click(function(){

            $(this).addClass('load').text('').append('<div class="loader"></div>');

            var data = {
                'action': 'loadmore_table',
                'query': ajax_Object.true_posts,
                'page' : ajax_Object.current_page,
                'step' : ajax_Object.step,
                'max_pages' : ajax_Object.max_pages
            };

            $.ajax({
                url: ajax_Object.url,
                data: data,
                type:'POST',
                success:function(data){

                    if( data ) {
                        $('.loader').remove();
                        $('#true_loadmore').removeClass('load').text('SHOW MORE');
                        console.log('test');
                        $('#table-load-js').append(data);
                        ajax_Object.current_page = parseInt(ajax_Object.current_page) + page_table;
                        if (ajax_Object.current_page >= ajax_Object.max_pages) $("#true_loadmore").remove();
                    } else {
                        $('#true_loadmore').remove();
                    }
                    toCasino();
                }
            });

        });
    });
}
function resetForm(){
    $('#commentform').reset();
    validator.resetForm();
}

function validateForm(){
    if (validator.form()) {
        $('#commentform').submit();
    }
}

validator = $("#commentform").validate({
    rules: {
        author: "required",
        email: {
            required: true,
            email: true
        },
        url: {
            url: true
        },
        comment: "required"

    },
    messages: {
        author: "S'il vous plaît entrez votre nom",
        email: {
            required: "Veuillez entrer une adresse courriel",
            email: "S'il vous plaît, mettez une adresse email valide"
        },
        url: "Veuillez entrer une URL valide, par exemple http://www.mysite.com",
        comment: "S'il vous plaît inclure votre commentaire"
    }
});

(function() {
// IE polyfill
	var ElementPrototype = window.Element.prototype;

	if (typeof ElementPrototype.matches !== 'function') {
		ElementPrototype.matches = ElementPrototype.msMatchesSelector || ElementPrototype.mozMatchesSelector || ElementPrototype.webkitMatchesSelector || function matches(selector) {
			var element = this;
			var elements = (element.document || element.ownerDocument).querySelectorAll(selector);
			var index = 0;

			while (elements[index] && elements[index] !== element) {
				++index;
			}

			return Boolean(elements[index]);
		};
	}

	if (typeof ElementPrototype.closest !== 'function') {
		ElementPrototype.closest = function closest(selector) {
			var element = this;

			while (element && element.nodeType === 1) {
				if (element.matches(selector)) {
					return element;
				}

				element = element.parentNode;
			}

			return null;
		};
	}
})();

document.addEventListener('click', function (event) {
	var element = event.target.closest('[data-ga-context-element]');

	if ( !element ) {
		return;
	}

	var eventAction = element.dataset.gaContextElement;
	var eventLabel = element.dataset.casino;

	dataLayer.push({
		'event': 'GAevent',
		'eventCategory': 'toCasino',
		'eventAction': eventAction,
		'eventLabel': eventLabel
	});
}, false);


var showMore = $('.js-show-more');
var contentHide =  $('.content-hide');
setTimeout(function() {
    showMore.fadeTo(400, 1).trigger('click');
}, 2000);

showMore.click(function () {
    contentHide.toggleClass("js-show-content");
    if(contentHide.hasClass("js-show-content")) {
        $(this).text("Show less");
        $(this).addClass('active');
    } else {
        $(this).text("Show more");
        $(this).removeClass('active');
    }
});